import { quickCards } from '@/mocks/siteContent';
import { VerdictChip } from './kit';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200">
      {/* faint editorial texture */}
      <div
        className="pointer-events-none absolute inset-0 -z-0"
        style={{
          backgroundImage:
            'radial-gradient(60% 55% at 12% 8%, oklch(var(--accent-100) / 0.55), transparent 60%), radial-gradient(45% 48% at 92% 4%, oklch(var(--primary-100) / 0.5), transparent 62%)',
        }}
      />
      <div className="relative z-10 mx-auto max-w-6xl px-4 pb-14 pt-12 md:px-6 md:pb-20 md:pt-16">
        <div className="max-w-3xl">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50/80 px-3 py-1.5 text-xs text-foreground-600">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-eye-line text-[10px]" aria-hidden="true" />
            </span>
            五一网传消息辟谣与实锤 · 本期归档
          </p>
          <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
            五一网传消息，
            <br />
            一条条求证给你看。
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-lg">
            针对五一期间流传的网络传闻，我们汇总网传消息、聊天记录与截图流出，区分「辟谣」与「实锤」，
            并按编号留档、持续更新结论，帮你少踩坑、不转错。
          </p>

          <dl className="mt-7 grid max-w-lg grid-cols-3 gap-4 border-t border-background-300 pt-5 text-center">
            {[
              { n: '9 起', t: '已定论' },
              { n: '4 起', t: '求证中' },
              { n: '100%', t: '附原始出处' },
            ].map((s) => (
              <div key={s.t}>
                <dt className="sr-only">{s.t}</dt>
                <dd className="font-heading text-2xl font-bold text-accent-700 md:text-3xl">{s.n}</dd>
                <dd className="mt-1 text-xs text-foreground-600">{s.t}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* multi-card parallel first screen */}
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {quickCards.map((c) => (
            <a
              key={c.no}
              href="#verdict"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="mb-5 flex items-center justify-between">
                <span className="font-heading text-2xl font-bold text-background-300 transition-colors group-hover:text-primary-400">
                  {c.no}
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-800">
                  {c.category}
                </span>
              </div>
              <h2 className="mb-3 flex-1 font-heading text-base font-bold leading-snug text-foreground-950">
                {c.claim}
              </h2>
              <div className="mb-3">
                <VerdictChip verdict={c.verdictKey as 'debunked' | 'confirmed' | 'pending'} />
              </div>
              <p className="text-xs leading-relaxed text-foreground-600">{c.note}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                查看求证
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}